import EsqueciMinhaSenhaGex from "@/views/auth/EsqueciMinhaSenhaGex.vue";
import { createRouter, createWebHistory } from "vue-router";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import LoginLayout from "@/layouts/LoginLayout.vue";
import HomeView from "@/views/HomeView.vue";
import CadastroView from "@/views/auth/CadastroView.vue";
import ListaUsuariosView from "@/views/usuarios/ListaUsuariosView.vue";
import loginGexView from "@/views/auth/loginGexView.vue";
import LoginSigaaView from "@/views/auth/LoginSigaaView.vue";

import { jwtDecode } from "jwt-decode";
import AcaoView from "@/views/acoes/AcaoView.vue";
import MenuAcoesView from "@/views/acoes/MenuAcoesView.vue";
import NoticiaView from "@/views/noticias/NoticiaView.vue";
import MenuAtividadesComponent from "@/components/atividades/MenuAtividadesComponent.vue";
import MenuNoticiasView from "@/views/noticias/MenuNoticiasView.vue";
import MenuCertificadosEDeclaracoesView from "@/views/acoes/MenuCertificadosEDeclaracoesView.vue";
import MenuTarefasAcao from "@/components/tarefas/MenuTarefasAcao.vue";
import CentralDaCoordenacao from "@/views/acoes/CentralDaCoordenacao.vue";
import AtividadeView from "@/views/atividades/AtividadeView.vue";
import FormCadastroAtividade from "@/components/atividades/FormCadastroAtividade.vue";
import FormCadastroEncontro from "@/components/encontros/FormCadastroEncontro.vue";
import FormCadastroTarefa from "@/components/tarefas/FormCadastroTarefa.vue";
import TarefaView from "@/views/tarefas/TarefaView.vue";
import userInfos from "@/utils/userInfos"; // Importar o userInfos
import { useAuthStore } from "@/stores/auth";
import PerfilUsuarioView from "@/views/usuarios/PerfilUsuarioView.vue";
import FormFrequenciaEncontro from "@/components/encontros/FormFrequenciaEncontro.vue";
import ResultadosView from "@/views/ResultadosView.vue";
import AtividadesCentralDoCoordenador from "@/components/central-coordenador/AtividadesCentralDoCoordenador.vue";
import TarefasCentralDoCoordenador from "@/components/central-coordenador/TarefasCentralDoCoordenador.vue";
import CadastroNoticia from "@/views/noticias/CadastroNoticia.vue";
import EditarEmail from "@/views/auth/EditarEmail.vue";
import NoticiasCentralCoordenacao from "@/components/central-coordenador/NoticiasCentralCoordenacao.vue";
import ParceriasCentralCoordenacao from "@/components/central-coordenador/ParceriasCentralCoordenacao.vue";

import CentralPrex from "@/views/prex/CentralPrex.vue";
import NoticiaViewPrex from "@/views/noticias/NoticiaViewPrex.vue";
import MenuVagasComponent from "@/components/vagas/MenuVagasComponent.vue";
import VagasView from "@/views/vagas/VagasView.vue";
import FormVagasView from "@/views/vagas/FormVagasView.vue";

import InformacoesAcaoView from "@/views/acoes/InformacoesAcaoView.vue";
import AjudaView from "@/views/ajudaView.vue";

import MenuParceriasComponent from "@/components/parcerias/MenuParceriasComponent.vue";
import DetalhesParceriaView from "@/views/parcerias/DetalhesParceriaView.vue";
import FormParceriaInterna from "@/components/parcerias/FormParceriaInterna.vue";
import FormParceriaExterna from "@/components/parcerias/FormParceriaExterna.vue";
import acaoService from "@/service/acaoService";

// Você precisará criar estes componentes ou usar placeholders temporários
const DeclaracoesAcao = {
  template: "<div>Minhas Declarações/Certificados</div>",
};

const routes = [
  {
    path: "/",
    name: "home",
    component: DefaultLayout,
    children: [
      {
        path: "",
        name: "home-page",
        component: HomeView,
        beforeEnter: (to, from, next) => {
          if (to.query.token) {
            next({ name: "recuperar-senha", query: { token: to.query.token } });
          } else {
            next();
          }
        },
      },
      {
        path: "/central-ajuda",
        name: "central-ajuda",
        component: AjudaView,
      },
      {
        path: "/resultados",
        name: "resultados",
        component: ResultadosView,
      },
      {
        path: "/home-noticia/:noticiaId",
        name: "home-noticia",
        component: NoticiaView,
        props: (route) => ({
          noticiaId: route.params.noticiaId,
          ...route.params,
        }),
      },
      {
        path: "/home-atividade/:atividadeId",
        name: "home-atividade",
        component: AtividadeView,
        props: (route) => ({
          atividadeId: route.params.atividadeId,
          ...route.params,
        }),
      },
      {
        path: "/suas-acoes",
        name: "suas-acoes",
        alias: "/acoes",
        component: MenuAcoesView,
      },
      {
        path: "/atividades",
        alias: "/Atividades",
        name: "atividades",
        component: MenuAtividadesComponent,
      },
      {
        // Dashboard de toda a UFC (sem acaoId): nível inicial UFC
        path: "dashboard",
        name: "dashboard-ufc",
        component: () => import("@/views/DashBoard.vue"),
      },
      {
        path: "/parcerias",
        alias: "/Parcerias",
        name: "parcerias",
        component: MenuParceriasComponent,
      },
      {
        path: "/acao/:id/central-coordenacao/parcerias/:parceriaId/detalhes",
        name: "DetalhesParceria",
        component: DetalhesParceriaView,
        props: (route) => ({
          acaoId: route.params.id,
          id: route.params.id,
          parceriaId: route.params.parceriaId,
          ...route.params,
        }),
      },
      {
        path: "/atividades/:atividadeId",
        alias: "Atividades/:atividadeId",
        name: "AtividadeView",
        component: AtividadeView,
        props: (route) => ({
          atividadeId: route.params.atividadeId,
          ...route.params,
        }),
      },

      {
        path: "/acao/:id/formulario-parceria-externa",
        name: "formulario-parceria-externa",
        component: FormParceriaExterna,
        props: (route) => ({
          acaoId: route.params.id,
          id: route.params.id,
        }),
      },
      {
        path: "/acao/:id/formulario-parceria-interna",
        name: "formulario-parceria-interna",
        component: FormParceriaInterna,
        props: (route) => ({
          acaoId: route.params.id,
          id: route.params.id,
        }),
      },
      {
        path: "/vagas",
        name: "vagas",
        component: MenuVagasComponent,
      },
      {
        path: "/vaga/:vagaId",
        alias: "/Vaga/:vagaId",
        name: "VagasView",
        component: VagasView,
        props: (route) => ({
          vagaId: route.params.vagaId,
          ...route.params,
        }),
      },
      {
        path: "/acao/:id/vaga/:vagaId",
        alias: "/acao/:id/Vaga/:vagaId",
        name: "VagasViewAcao",
        component: VagasView,
        props: (route) => ({
          acaoId: route.params.id,
          id: route.params.id,
          vagaId: route.params.vagaId,
          ...route.params,
        }),
      },
      {
        path: "/acao/:id/cadastrar-vaga",
        name: "cadastrar-vaga",
        component: FormVagasView,
        props: (route) => ({
          acaoId: route.params.id,
          id: route.params.id,
        }),
      },
      {
        path: "/acao/:id/editar-vaga/:vagaId",
        name: "editar-vaga",
        component: FormVagasView,
        props: (route) => ({
          acaoId: route.params.id,
          id: route.params.id,
          vagaId: route.params.vagaId,
          ...route.params,
        }),
      },
      {
        path: "/editar-vaga/:vagaId",
        name: "editar-vaga-direto",
        component: FormVagasView,
        props: (route) => ({
          vagaId: route.params.vagaId,
          ...route.params,
        }),
      },
      {
        path: "/acao/:id/atividades/:atividadeId",
        alias: "/acao/:id/Atividades/:atividadeId",
        children: [
          {
            path: "",
            name: "atividade-acao",
            component: AtividadeView,
            props: (route) => ({
              acaoId: route.params.id,
              id: route.params.id,
              atividadeId: route.params.atividadeId,
              ...route.params,
            }),
          },
          {
            path: "cadastro-frequencia/:encontroId",
            name: "cadastro-frequencia-atividade",
            component: FormFrequenciaEncontro,
            props: (route) => ({
              acaoId: route.params.id,
              id: route.params.id,
              atividadeId: route.params.atividadeId,
              encontroId: route.params.encontroId,
              ...route.params,
            }),
          },
        ],
      },
      {
        path: "/noticias",
        alias: "/Noticias",
        name: "noticias",
        component: MenuNoticiasView,
      },
      {
        path: "/noticias/:noticiaId",
        name: "NoticiaView",
        component: NoticiaView,
        props: (route) => ({
          noticiaId: route.params.noticiaId,
          ...route.params,
        }),
      },
      {
        path: "/acao/:id/noticias/:noticiaId",
        name: "noticia-acao-view",
        component: NoticiaView,
        props: (route) => ({
          acaoId: route.params.id,
          id: route.params.id,
          noticiaId: route.params.noticiaId,
          ...route.params,
        }),
      },

      {
        path: "/Meus-Certificados-e-Declaracoes",
        name: "certificados-declaracoes",
        component: MenuCertificadosEDeclaracoesView,
      },
      {
        path: "lista-usuarios",
        name: "lista-usuarios",
        component: ListaUsuariosView,
      },
      {
        path: "admin/termos",
        name: "admin-termos",
        component: () => import("@/views/admin/GestaoTermosView.vue"),
        beforeEnter: (to, from, next) => {
          const auth = useAuthStore();
          if (auth.isAutenticado && auth.hasRole("ADMINISTRADOR")) {
            next();
          } else {
            next({ name: "home" });
          }
        },
      },
      {
        path: "perfil",
        name: "perfil",
        component: PerfilUsuarioView,
      },
      {
        path: "central-prex",
        name: "central-prex",
        component: CentralPrex,
        beforeEnter: (to, from, next) => {
          checkUsuarioPrex(to, from, next);
        },
      },
      {
        path: "central-unidade",
        name: "central-unidade",
        component: () => import("@/views/unidade/CentralUnidade.vue"),
        beforeEnter: (to, from, next) => {
          checkCoordenadoriaUnidade(to, from, next);
        },
      },
      {
        path: "central-prex/noticia/:noticiaId",
        name: "noticia-prex-view",
        component: NoticiaViewPrex,
        props: (route) => ({
          noticiaId: route.params.noticiaId,
          mostrarBotoes: true,
        }),
      },
      {
        path: "central-prex/parcerias/:parceriaId",
        name: "parceria-prex-view",
        component: DetalhesParceriaView,
        props: (route) => ({
          parceriaId: route.params.parceriaId,
        }),
      },
      // ROTA PRINCIPAL DA AÇÃO COM ROTAS ANINHADAS
      {
        path: "/acao/:id",
        name: "AcaoView",
        component: AcaoView,
        props: true,
        children: [
          {
            path: "",
            name: "acao-default",
            redirect: { name: "acao-informacoes" },
          },
          {
            path: "atividades-acao",
            alias: "atividades",
            name: "acao-atividades",
            component: MenuAtividadesComponent,
            props: (route) => ({
              acaoId: route.params.id,
              id: route.params.id,
              ...route.params,
            }),
          },
          {
            path: "noticias-acao",
            alias: "noticias",
            name: "acao-noticias",
            component: MenuNoticiasView,
            props: (route) => ({
              acaoId: route.params.id,
              id: route.params.id,
              isCoordenador: route.meta.isCoordenador,
            }),
          },
          {
            path: "tarefas",
            name: "acao-tarefas",
            component: MenuTarefasAcao,
            props: (route) => ({
              acaoId: route.params.id,
              id: route.params.id,
              ...route.params,
            }),
          },
          {
            path: "cadastrar-tarefa",
            name: "cadastrar-tarefa",
            component: FormCadastroTarefa,
            props: (route) => ({
              acaoId: route.params.id,
              id: route.params.id,
              ...route.params,
            }),
          },
       

          {
            path: "informacoes",
            name: "acao-informacoes",
            component: InformacoesAcaoView,
            props: (route) => ({
              acaoId: route.params.id,
              id: route.params.id,
              ...route.params,
            }),
          },
          {
            path: "declaracoes",
            name: "acao-declaracoes",
            component: DeclaracoesAcao,
            props: (route) => ({
              acaoId: route.params.id,
              id: route.params.id,
              ...route.params,
            }),
          },
          {
            path: "vagas-acao",
            alias: "vagas",
            name: "acao-vagas",
            component: MenuVagasComponent,
            props: (route) => ({
              acaoId: route.params.id,
              id: route.params.id,
              ...route.params,
            }),
          },
          {
            path: "parcerias-acao",
            alias: "parcerias",
            name: "acao-parcerias",
            redirect: (to) => ({
              name: "parcerias-central-coordenacao",
              params: to.params,
            }),
          },
          {
            path: "dashboard",
            name: "acao-dashboard",
            component: () => import("@/views/DashBoard.vue"),
            props: (route) => ({
              acaoId: route.params.id,
              id: route.params.id,
              ...route.params,
            })
          },
          {
            path: "central-coordenacao",
            name: "acao-central-coordenacao",
            component: CentralDaCoordenacao,
            redirect: { name: "atividades-central-coordenacao" },
            children: [
              {
                path: "atividades",
                alias: "Atividades",
                name: "atividades-central-coordenacao",
                component: AtividadesCentralDoCoordenador,
                props: (route) => ({
                  acaoId: route.params.id,
                  id: route.params.id,
                  ...route.params,
                }),
              },
              {
                path: "noticias",
                alias: "Noticias",
                name: "noticias-central-coordenacao",
                component: NoticiasCentralCoordenacao,
                props: (route) => ({
                  acaoId: route.params.id,
                  id: route.params.id,
                  ...route.params,
                }),
              },
              {
                path: "parcerias",
                alias: "Parcerias",
                name: "parcerias-central-coordenacao",
                component: ParceriasCentralCoordenacao,
                props: (route) => ({
                  acaoId: route.params.id,
                  id: route.params.id,
                  ...route.params,
                }),
              },
              {
                path: "tarefas",
                alias: "Tarefas",
                name: "tarefas-central-coordenacao",
                component: TarefasCentralDoCoordenador,
                props: (route) => ({
                  acaoId: route.params.id,
                  id: route.params.id,
                  ...route.params,
                }),
              },
            ],
            props: (route) => ({
              acaoId: route.params.id,
              id: route.params.id,
              ...route.params,
            }),
            beforeEnter: (to, from, next) => {
              checkCoordenador(to, from, next);
            },
          },
        ],
      },
      {
        path: "/acao/:id/cadastrar-noticia",
        name: "cadastrar-noticia",
        component: CadastroNoticia,
        props: (route) => ({
          acaoId: route.params.id,
          atividadeObjeto: window.history.state?.atividadeObjeto || null,
          ...route.params,
        }),
      },
      {
        path: "/acao/:id/cadastrar-atividade",
        name: "cadastrar-atividade",
        component: FormCadastroAtividade,
        props: (route) => ({
          acaoId: route.params.id,
          ...route.params,
        }),
      },
      {
        path: "/acao/:id/cadastrar-atividade/encontros",
        name: "cadastrar-encontros-atividade",
        component: FormCadastroEncontro,
        props: (route) => ({
          acaoId: route.params.id,
          ...route.params,
        }),
      },
      {
        path: "/acao/:id/editar-atividade/:atividadeId",
        name: "editar-atividade",
        component: FormCadastroAtividade,
        props: (route) => ({
          acaoId: route.params.id,
          atividadeId: route.params.atividadeId,
          ...route.params,
        }),
      },
      {
        path: "/acao/:id/editar-atividade/:atividadeId/encontros",
        name: "editar-encontros-atividade",
        component: FormCadastroEncontro,
        props: (route) => ({
          acaoId: route.params.id,
          atividadeId: route.params.atividadeId,
          ...route.params,
        }),
      },
      {
        path: "/acao/:id/atividades/:atividadeId/adicionar-encontros",
        name: "adicionar-encontros-atividade",
        component: FormCadastroEncontro,
        props: (route) => ({
          acaoId: route.params.id,
          atividadeId: route.params.atividadeId,
          modoAdicao: true,
        }),
      },
      {
        path: "/acao/:id/editar-noticia/:noticiaId",
        name: "editar-noticia",
        component: CadastroNoticia,
        props: (route) => ({
          acaoId: route.params.id,
          noticiaId: route.params.noticiaId,
          ...route.params,
        }),
      },
      {
        path: "/acao/:id/tarefas/:tarefaId",
        name: "acao-tarefas-view",
        component: TarefaView,
        props: (route) => ({
          tarefaId: route.params.tarefaId,
          ...route.params,
        }),
      },
    ],
  },
  {
    path: "/login",
    component: LoginLayout,
    children: [
      {
        path: "",
        name: "login",
        component: LoginSigaaView,
      },
      {
        path: "autenticacao-sigaa",
        name: "autenticacao-sigaa",
        component: LoginSigaaView,
      },
      {
        path: "autenticacao-gex",
        name: "autenticacao-gex",
        component: loginGexView,
      },
      // Junto com as outras rotas de login
      {
        path: "/recuperar-senha",
        name: "recuperar-senha",
        component: EsqueciMinhaSenhaGex, // mesmo componente, ele já lida com o token
      },
      {
        path: "/recuperar-senha-perfil",
        name: "recuperar-senha-perfil",
        component: EsqueciMinhaSenhaGex, // mesmo componente, ele já lida com o token
      },
      {
        path: "/alterar-email",
        name: "alterar-email",
        component: EditarEmail,
      },
    ],
  },
  {
    name: "cadastro",
    path: "/cadastro",
    component: CadastroView,
  },
  {
    path: "/mapa",
    alias: "/mapa-tela-cheia",
    name: "mapa-tela-cheia",
    component: () => import("@/views/mapa/MapaFullscreenView.vue"),
  },
  {
    path: "/:catchAll(.*)",
    name: "not-found",
    redirect: "/",
  },
];

// Função para verificar se o usuário é coordenador
function checkCoordenador(to, from, next) {
  try {
    const userInfo = userInfos.getUserInfos();

    if (!userInfo || !userInfo.scope) {
      // Se não há informações do usuário, redireciona para a rota anterior
      next(from.path || "/");
      return;
    }

    const userScope = userInfo.scope;
    const scopes = userScope.split(" ");
    const isCoordenador = ["SCOPE_COORDENADOR", "SCOPE_ADMINISTRADOR"].some((s) => scopes.includes(s));

    if (isCoordenador) {
      // Se é coordenador, permite o acesso
      next();
    } else {
      // Se não é coordenador, redireciona para a rota anterior
      next(from.path || "/");
    }
  } catch (error) {
    console.error("Erro ao verificar permissão de coordenador:", error);
    // Em caso de erro, redireciona para a rota anterior
    next(from.path || "/");
  }
}

function checkUsuarioPrex(to, from, next) {
  try {
    const userInfo = userInfos.getUserInfos();

    if (!userInfo || !userInfo.scope) {
      // Se não há informações do usuário, redireciona para a rota anterior
      next(from.path || "/");
      return;
    }

    const userScope = userInfo.scope;
    const scopes = userScope.split(" ");
    const isPrex = ["SCOPE_PREX", "SCOPE_ADMINISTRADOR"].some((s) => scopes.includes(s));

    if (isPrex) {
      // Se é usuário PREX, permite o acesso
      next();
    } else {
      // Se não é usuário PREX, redireciona para a rota anterior
      next(from.path || "/");
    }
  } catch (error) {
    console.error("Erro ao verificar permissão de usuário PREX:", error);
    // Em caso de erro, redireciona para a rota anterior
    next(from.path || "/");
  }
}

// Verifica se o usuário é coordenador de UNIDADE (regra COORDENADORIA).
// Usa a store para cobrir scope, regras e authorities do usuário logado.
function checkCoordenadoriaUnidade(to, from, next) {
  try {
    const auth = useAuthStore();

    if (auth.hasRole("COORDENADORIA")) {
      // Se coordena uma unidade, permite o acesso
      next();
    } else {
      // Se não coordena unidade, redireciona para a rota anterior
      next(from.path || "/");
    }
  } catch (error) {
    console.error("Erro ao verificar permissão de coordenadoria:", error);
    // Em caso de erro, redireciona para a rota anterior
    next(from.path || "/");
  }
}

async function checkAcaoDashboard(to, from, next) {
  try {
    const auth = useAuthStore();
    if (!auth.isAutenticado) {
      next({ name: "login" });
      return;
    }
    if (
      auth.hasRole("ADMINISTRADOR") ||
      auth.hasRole("ADMIN") ||
      auth.hasRole("PREX")
    ) {
      next();
      return;
    }
    const acaoId = to.params.id;
    const ehCoord = await acaoService.verificarCoordenador(acaoId);
    if (ehCoord) {
      next();
    } else {
      next(`/acao/${acaoId}/informacoes`);
    }
  } catch (error) {
    console.error("Erro ao verificar permissão do painel da ação:", error);
    next(`/acao/${to.params.id}/informacoes`);
  }
}

async function checkDashboardUfc(to, from, next) {
  try {
    const auth = useAuthStore();
    if (!auth.isAutenticado) {
      next({ name: "login" });
      return;
    }
    if (
      auth.hasRole("ADMINISTRADOR") ||
      auth.hasRole("ADMIN") ||
      auth.hasRole("PREX") ||
      auth.hasRole("COORDENADOR") ||
      auth.hasRole("COORDENADORIA")
    ) {
      next();
      return;
    }
    next("/");
  } catch (error) {
    console.error("Erro ao verificar permissão do dashboard UFC:", error);
    next("/");
  }
}


const router = createRouter({
  history: createWebHistory(),
  routes,

  scrollBehavior() {
    return {
      top: 0,
      left: 0,
    };
  },
});


const withoutAuthorization = [
  "login",
  "autenticacao-gex",
  "autenticacao-sigaa",
  "cadastro",
  "recuperar-senha",
  "recuperar-senha-perfil",
  "verificacao-pin",
  // Rotas públicas
  "home",
  "home-page",
  "resultados",
  "noticias",
  "atividades",
  "Atividades",
  "vagas",
  "VagasView",
  "VagasViewAcao",
  "home-noticia",
  "home-atividade",
  "NoticiaView",
  "AtividadeView",
  "ParceriaView",
  "AcaoView",
  "acao-default",
  "acao-atividades",
  "acao-noticias",
  "acao-vagas",
  "acao-informacoes",
  "acao-parcerias",
  "alterar-email",
  "parcerias",
  "central-ajuda",
  "suas-acoes",
  "acoes",
  "dashboard-ufc",
  "acao-dashboard",
  "mapa-tela-cheia",
];

function validToken(token) {
  if (!token) return false; // Verifica se é null, undefined ou string vazia

  try {
    let decodedToken = jwtDecode(token);
    let dateNow = Date.now() / 1000;

    // Apenas verifica se a data de expiração é maior que agora
    if (decodedToken.exp > dateNow) {
      return true;
    }
    return false;
  } catch (error) {
    // Se o token estiver corrompido ou inválido, retorna false
    console.error("Erro ao decodificar token no router:", error);
    return false;
  }
}

router.beforeEach((to, from, next) => {
  let token = window.localStorage.getItem("auth_token");

  const isAcaoRoutePublic =
    (to.path === "/acao" || to.path.startsWith("/acao/")) &&
    !to.path.includes("/dashboard") &&
    !to.path.includes("/central-coordenacao") &&
    !to.path.includes("/cadastrar-");

  const isPublicRoute =
    withoutAuthorization.includes(to.name) ||
    withoutAuthorization.includes(to.path.replace(/^\//, "")) ||
    to.path === "/" ||
    to.path.startsWith("/suas-acoes") ||
    to.path.startsWith("/acoes") ||
    to.path.startsWith("/vagas") ||
    to.path.startsWith("/Vaga") ||
    to.path.startsWith("/noticias") ||
    to.path.startsWith("/atividades") ||
    to.path.startsWith("/Parcerias") ||
    isAcaoRoutePublic;

  if (to.name === "login" && validToken(token)) {
    // next({ path: "/" });
  } else if (isPublicRoute || validToken(token)) {
    next();
  } else {
    next({ name: "login" });
  }
});

export default router;